import type { ReactNode } from 'react';

import { cn } from './cn';

export type KbdProps = {
  children: ReactNode;
  className?: string;
};

export function Kbd({ children, className }: KbdProps) {
  return (
    <span
      className={cn(
        'inline-block min-w-4 rounded-md bg-neutral-200 px-1 py-0.5 text-center align-baseline text-2xs font-normal capitalize text-neutral-500',
        className,
      )}>
      {children}
    </span>
  );
}
